import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {BaseFillDataFormComponent} from '../base-fill-data-form-component';
import {WebsiteModel} from './website.model';
import {CustomValidators} from 'app/core/validator/custom-validators';
import WebsiteUtils from '../../../shared/website-utils';

@Component({
  selector: 'app-website-user-input',
  templateUrl: './website-user-input.component.html'
})
export class WebsiteUserInputComponent extends BaseFillDataFormComponent implements OnInit, OnDestroy {

  @Input() websiteEnum: WebsiteModel[];
  @Input() urlPlaceholder: string;
  @Input() isUserDataNumberType: boolean;
  @Input() mediaType: string;
  @Input() userNameInputName: string;
  @Input() urlInputName: string;
  @Input() websiteLabel: string;

  websiteForm: FormGroup;
  websites: WebsiteModel[];

  constructor() {
    super();
  }

  ngOnInit() {
    this.websites = [];
    for (const n in this.websiteEnum) {
      this.websites.push(this.websiteEnum[n]);
    }
    this.createForm();
  }

  private createForm() {
    this.websiteForm = new FormGroup({
      'service': new FormControl('', Validators.required)
    });
    this.websiteForm.addControl(this.urlInputName,
      new FormControl('', [CustomValidators.notEmpty, CustomValidators.correctWebsite(this.websiteEnum), CustomValidators.validateUrl]));
    this.websiteForm.addControl(this.userNameInputName,
      new FormControl('', [CustomValidators.notEmpty, CustomValidators.correctUsername()]));
    this.parentForm.addControl('websiteForm' + this.mediaType + this.formIndex, this.websiteForm);
  }

  ngOnDestroy(): void {
    this.parentForm.removeControl('websiteForm' + this.mediaType + this.formIndex);
  }

  updateUrl() {
    const website = this.websites.find(x => x['id'] === this.data['service']);
    const prefix = WebsiteUtils.commonWebsitePrefix + website['profileUrlPrefix'];
    const userName = WebsiteUtils.removeSpaces(this.data['userName']);
    this.data['url'] = prefix + (userName ? userName : '');
  }

  updateUserNameAndServiceId(): void {
    const newWebsiteUrl = WebsiteUtils.removeWebsitePrefix(WebsiteUtils.removeSpaces(this.data['url']));
    const website = WebsiteUtils.getWebsiteFromEnum(newWebsiteUrl, this.websiteEnum);
    if (website) {
      const name = WebsiteUtils.getUserNameFromWebsiteUrl(newWebsiteUrl, website);
      if (name) {
        this.data['userName'] = name;
      }

      this.data['service'] = website['id'];
      this.data['url'] = WebsiteUtils.commonWebsitePrefix + newWebsiteUrl;
    }
  }

  getUsernameLabel(): string {
    return this.isUserDataNumberType ? 'NETWORK.USER_ID_LABEL' : 'NETWORK.USERNAME_LABEL';
  }

  getUsernamePlaceholder(): string {
    return this.isUserDataNumberType ? 'NETWORK.PLACEHOLDER_ID' : 'NETWORK.PLACEHOLDER_NAME';
  }
}




// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/widgets/form-section/website-user-input/website-user-input.component.ts